
import { css } from 'lit';
export default css`
pc-office-card pc-heading[slot='heading'] > *{
  --heading-font-weight:500;
  --detail-line-height:normal;
  --detail-gap:var(--spacing-3);

  display:flex;
  column-gap:var(--spacing-3);
  row-gap:var(--spacing-2);
  flex-wrap:wrap;
  align-items:center;
}

pc-office-card [slot='address'] pc-icon-link{
  max-width:85%;
}
`;